<template>
    <v-layout fill-height class="data">
        <v-flex xs12 class="scroll-container">
            <v-list class="transparent" dense>
                <v-list-tile class="wrap row transparent mt-3 station-attrs" color="success"
                             v-for="attr in attrToShow" :key="attr">
                    <v-container pa-0 class="text-xs-center">
                    <v-layout wrap row>
                        <v-flex xs12 class="station-attr-label">
                            {{ $vuetify.t(`$vuetify.StationInfo.${attr}`)|uppercase}}
                        </v-flex>
                    </v-layout>
                    <v-layout wrap row>
                        <v-flex v-if="attr === 'totalCount'" xs12 class="station-attr-value">
                            {{station.bays.totalCount}}
                        </v-flex>
                        <v-flex v-else-if="attr === 'name'" xs12 class="station-attr-value">
                            {{station[attr]}} ({{$vuetify.t(`$vuetify.generic.station_statues.${$options.filters.lowercase(station.state)}`)| lowercase}})
                        </v-flex>
                        <v-flex v-else  xs12 class="station-attr-value">
                            {{station[attr]}}
                        </v-flex>
                    </v-layout>
                    </v-container>
                </v-list-tile>
            </v-list>
        </v-flex>
    </v-layout>
</template>

<script>

    export default {
        data() {
            return {
                attrToShow: ["name","address","totalCount", "freeBay", "availableVehicles"]

            }
        },
        props: {
            station: Object

        },

    }


</script>

<style lang="scss" scoped>


    .data {
        padding-bottom: 20px;

        .scroll-container{
            overflow-x: hidden;
            overflow-y: auto;

            & /deep/ .v-list {
                color: inherit;

                .station-attrs {
                    .v-list__tile{
                        font-size: 14px;
                        font-weight: bold;
                        padding: 0px;

                        .station-attr-value{
                            font-weight: 300;
                        }

                    }

                }
            }
        }


    }


</style>